import { inject, Injectable } from '@angular/core';

import { Layer, LayerWithAttributes } from '@connect-services/client/sdk/api';
import { EditModeCapabilities } from '@connect-services/client/services/map-edit-mode.service';
import { ProjectEditModeService } from '@connect-services/client/services/project-edit-mode.service';

export type CreateUiState = {
    disabled: boolean;
    tooltipKey?: string;
    visible: boolean;
};

@Injectable({
    providedIn: 'root',
})
export class EntityCreateUiService {
    private readonly projectEditModeService = inject(ProjectEditModeService);

    public getCreateState(params: {
        capabilities: EditModeCapabilities | undefined;
        isEditModeActive: boolean;
        layer: LayerWithAttributes | null;
    }): CreateUiState {
        const { capabilities, isEditModeActive, layer } = params;

        if (!capabilities || !isEditModeActive || !layer) {
            return {
                disabled: true,
                visible: false,
            };
        }

        const disabled =
            !capabilities.canCreate ||
            layer.hasGeom ||
            !this.projectEditModeService.editableLayerIds().includes(layer.id);

        const tooltipKey = this.getTooltipValue(layer, capabilities.canCreate);

        return {
            disabled,
            tooltipKey,
            visible: true,
        };
    }

    private getTooltipValue(layer: Layer, canCreate: boolean): string {
        if (!canCreate) {
            return 'insufficientPermissions';
        }

        if (layer.hasGeom) {
            return 'geometricLayerEntityCreatedOnMap';
        }

        if (!this.projectEditModeService.editableLayerIds().includes(layer.id)) {
            return 'editMode.layerStandardNotEditable';
        }

        return '';
    }
}
